import type { State } from '../State';
import { Dialog, splitDialogId } from './conservation.ruleset';

export function getTimesSeen(
  { conversation }: State,
  dialog: Dialog['id'],
): number {
  const [species, key] = splitDialogId(dialog);
  return conversation.dialogCounts[species]?.[key] ?? 0;
}
